<div class="alert-body">
    <i class="fal fa-check-circle fa-5x"></i>
    <h4>{{ 'REGISTRATION_SUCCESS_MODAL.TITLE' | translate }}</h4>
    <p class="text-gray">{{ 'REGISTRATION_SUCCESS_MODAL.FIRST_TEXT' | translate }}</p>
    <p class="text-gray">{{ 'REGISTRATION_SUCCESS_MODAL.SECOND_TEXT' | translate }}</p>
    <button nz-button nzType="primary" (click)="clickOk()">{{ 'REGISTRATION_SUCCESS_MODAL.BUTTON_OK' | translate }}</button>
</div>